<div class="modal-header">
  <h4 class="modal-title">
    @if (amenity) {
      Crear reservación para {{ amenity.name }} 
    }
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<div class="modal-body">
  <form
      id="formBooking"
      [formGroup]="formBooking"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          <div class="col-12 mb-4">
            <div class="row">

              <div class="col-12 mb-1">
                Calle
              </div>

              <div class="col-12">
                <ng-select
                  [items]="streetBuildingService.streetsBuildings"
                  [loading]="streetBuildingService.loading" 
                  [bindLabel]="'name'"
                  [bindValue]="'streetBuildingId'"
                  formControlName="streetBuildingId"
                  placeholder="Selecciona una calle"
                  (change)="onChangeStreetBuilding($event)">
                </ng-select>
                <div *ngIf="submitted && f['streetBuildingId'].errors" class="invalid-feedback d-block">
                  <div *ngIf="f['streetBuildingId'].errors['required']">
                    Por favor, seleccione la calle
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="col-12 mb-4">
            <div class="row">

              <div class="col-12 mb-1">
                Casas
              </div>

              <div class="col-12">
                <ng-select
                  [items]="housesFlats"
                  [bindLabel]="'number'"
                  [bindValue]="'houseFlatId'"
                  formControlName="houseFlatId"
                  placeholder="Selecciona casa">
                </ng-select>
                <div *ngIf="submitted && f['houseFlatId'].errors" class="invalid-feedback d-block">
                  <div *ngIf="f['houseFlatId'].errors['required']">
                    Por favor, seleccione una casa
                  </div>
                </div>
              </div>

            </div>
          </div>

          @if(true) {

            <div class="col-12 mb-4">
              <div class="mb-1">
                Fecha de reservación
              </div>
              <div class="input-group">
                <input
                  class="form-control"
                  placeholder="yyyy-mm-dd"
                  name="d2"
                  formControlName="dateSelected"
                  ngbDatepicker
                  #d2="ngbDatepicker"
                  (dateSelect)="onDateSelection($event)"
                />
                <button 
                  class="btn btn-outline-secondary" 
                  (click)="d2.toggle()" 
                  type="button">
                  <i class="material-icons">calendar_today</i>
                </button>
              </div>
            </div>
  
            <div class="col-12 mb-4">
              <div class="row">
  
                <div class="col-12 mb-1">
                  Horarios
                </div>
  
                <div class="col-12">
                  <ng-select
                    [items]="timetables"
                    bindValue="timetableId"
                    bindLabel="startHour"
                    formControlName="timetableId"
                    [loading]="loadingSchedules"
                    placeholder="Seleccione horario"
                    (change)="onChangeTimetable($event)">
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.startHour }} - {{ item.endHour }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <div class="d-flex justify-content-between">
                        {{ item.startHour }} - {{ item.endHour }} 
                        <span 
                          class="badge"
                          [ngClass]="{
                            'text-bg-success': item.capacity === 0,
                            'text-bg-warning': item.capacity > 0,
                            'text-bg-danger': item.capacity === amenity?.capacity
                          }">
                          {{ item.capacity }} / {{ amenity?.capacity }} 
                        </span>
                      </div>
                    </ng-template>
                  </ng-select>
                  <div *ngIf="submitted && f['timetableId'].errors" class="invalid-feedback d-block">
                    <div *ngIf="f['timetableId'].errors['required']">
                      Por favor, seleccione una horario
                    </div>
                  </div>
                </div>
  
              </div>
            </div>

            <div class="col-12">
              <div class="row">

                <div class="col-12 mb-2">
                  Número de invitados
                </div>

                <p-inputNumber 
                  formControlName="guests" 
                  [showButtons]="true" 
                  buttonLayout="horizontal" 
                  spinnerMode="horizontal" 
                  styleClass="w-100 mb-4"
                  min="0"
                  decrementButtonClass="p-button-secondary"
                  incrementButtonClass="p-button-secondary" 
                  incrementButtonIcon="pi pi-plus" 
                  decrementButtonIcon="pi pi-minus" />

              </div>
            </div>

            @if(timetableSelected) {

              @if(timetableSelected.canBeBlocked) {

                <div class="col-12 mt-2 mb-4">
                  <div class="row">
                    <div class="col-8">
                      ¿Reservar todo el horario seleccionado?
                    </div>
                    <div class="col-4 text-end">
                      <p-inputSwitch
                        formControlName="isBlocked">
                      </p-inputSwitch>
                    </div>
                  </div>
                </div>

              }

            }

          }

        </div>
      </div>
    </form>
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formBooking"
      class="btn btn-success w-100">
      Reservar
    </button>
  </div>
</div>
